import { fetchAddons } from "~/services/masterdataService";

export const useMasterDataStore = defineStore("masterData", () => {
  const ratePlanMasterdata = ref();
  const meetingRoomMasterData = ref();
  const meetingRoomServiceMasterData = ref();
  const serviceNamesMasterData = ref();
  const roomUpgradesMasterData = ref();

  const availabelCountries = ref([]);
  async function getAddonsMasterData() {
    const expands = ["reservationExtraServices", "roomTypes", "breakfast"];
    const addonsMasterdataResponse = await fetchAddons(
      travelData.hotelCodes,
      localeToCfLocal(locale.value),
      expands,
    ).catch((error) => {
      console.error(error);
    });

    serviceNamesMasterData.value = [];
    addonsMasterdataResponse.data.reservationExtraServices.forEach(
      (extraService) => {
        extraService.serviceCodes.forEach((serviceCode) => {
          serviceNamesMasterData.value.push({
            code: serviceCode,
            name: extraService.name,
          });
        });
      },
    );
  }

  return {
    ratePlanMasterdata,
    meetingRoomMasterData,
    meetingRoomServiceMasterData,
    serviceNamesMasterData,
    roomUpgradesMasterData,
    availabelCountries,
    getAddonsMasterData,
  };
});
